import { useEffect } from 'react';

/**
 * Custom hook: on mount, read `token` and optional `uid`/`user_uid` from
 * the URL query string. If present, save them to localStorage, remove the
 * sensitive query params from the address bar, and call `getUser(dispatch)`
 * to populate the redux store.
 *
 * This keeps the URL-token auto-login logic in one place and uses the
 * existing `getUser` (auth/me) implementation.
 */
export default function useUrlTokenLogin() {
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;

      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const uid = params.get('uid') || params.get('user_uid');

      if (!token && !uid) return;

      if (token) {
        localStorage.setItem('token', token);
      }
      if (uid) {
        localStorage.setItem('uid', uid);
      }

      // Remove sensitive params from URL without reloading
      params.delete('token');
      params.delete('uid');
      params.delete('user_uid');
      const newSearch = params.toString();
      const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
      window.history.replaceState({}, document.title, newUrl);

    } catch (err) {
      // Avoid breaking startup if anything goes wrong
      // eslint-disable-next-line no-console
      console.warn('useUrlTokenLogin failed:', err);
    }
    // We only want to run this once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
